<template>
  <div v-if="hasAttachments" class="attachments-list">
    <div
      v-for="item in attachments"
      :key="item.id"
      class="attachments-list__item"
    >
      <a :href="item.url" :title="item.name" target="_blank">
        <dd-button
          class="attachments-list__item-button"
          type="capsule"
          color="white"
          size="medium"
        >
          <img :src="getFileTypeIcon(item.type)" class="attachments-list__item-icon">
          <span class="attachments-list__item-name">{{ item.name }}</span>
        </dd-button>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

// Icons
import GoogleDriveIcon from './img/attachment-google-drive.svg'
import PdfIcon from './img/attachment-pdf.svg'
import ExcelIcon from './img/attachment-excel.svg'
import ImageIcon from './img/attachment-image.svg'
import WordIcon from './img/attachment-word.svg'
import ZipIcon from './img/attachment-zip.svg'
import AttachmentIcon from './img/attachment.svg'
import { IAttachment } from '@/types/data-objects/attachments'
import { IDynamicObject } from '@/types'

export default defineComponent({
  name: 'AttachmentsList',

  props: {
    attachments: {
      type: Array as () => IAttachment[],
      required: true,
    },
  },

  computed: {
    hasAttachments(): boolean {
      return this.attachments.length > 0
    },
    fileTypesIcons(): IDynamicObject {
      return {
        googleDrive: GoogleDriveIcon,
        file_pdf: PdfIcon,
        file_img: ImageIcon,
        file_doc: WordIcon,
        file_xls: ExcelIcon,
        file_zip: ZipIcon,
        file: AttachmentIcon,
      }
    },
  },

  methods: {
    getFileTypeIcon(type: string): string {
      return this.fileTypesIcons[type]
    },

    /**
     * Remove extension from filename
     */
    getName(name: string): string {
      if (name.includes('.')) {
        return name
          .split('.')
          .slice(0, -1)
          .join('.')
      }
      return name
    },

    getFileExtension(name: string): string {
      const re = /(?:\.([^.]+))?$/
      const extension = re.exec(name)[1]

      return extension ? `${extension}` : ''
    },
  },
})
</script>

<style lang="scss">
.attachments-list {
  display: flex;
  flex-wrap: wrap;

  @include media-breakpoint-up(md) {
    border-top: $border--dotted-light;
  }

  &__item {
    margin-top: 8px;

    &:not(:last-child) {
      margin-right: 8px;
    }

    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    a:hover {
      text-decoration: none;
    }

    &-button.dd-button {
      width: 100%;

      .dd-button__content {
        width: 100%;
      }
    }

    &-icon {
      width: 20px;
      min-width: 20px;
      height: 20px;
      max-height: 20px;
      margin-right: 4px;
    }

    &-name {
      @include lettering--p-sm;
      @include single-line-ellipsis;
    }
  }
}
</style>
